import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/question_mark_FILL.svg'
import _imports_1 from '@/assets/images/send_arrow.svg'


const _hoisted_1 = { class: "upload-block-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "upload-secondary-main-block"
}
const _hoisted_3 = { class: "upload-waiting-text h5-grey" }
const _hoisted_4 = {
  key: 1,
  class: "upload-view-content-wrapper"
}
const _hoisted_5 = { class: "upload-title-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "upload-view-title" }, "Upload a file", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "upload-question-icon",
  src: _imports_0
}, null, -1)
const _hoisted_8 = { class: "update-view-info-names" }
const _hoisted_9 = { class: "default-text" }
const _hoisted_10 = { class: "update-view-info-project-block" }
const _hoisted_11 = { class: "update-view-info-project-name small-text" }
const _hoisted_12 = { class: "time-entry-upload-section-container" }
const _hoisted_13 = { class: "section-name default-text" }
const _hoisted_14 = { class: "default-text-orange" }
const _hoisted_15 = { class: "roles-div" }
const _hoisted_16 = { class: "buttons-container" }
const _hoisted_17 = { class: "time-entry-upload-section-container" }
const _hoisted_18 = { class: "section-name-what default-text" }
const _hoisted_19 = { class: "default-text-orange" }
const _hoisted_20 = { class: "select-menu" }
const _hoisted_21 = {
  key: 0,
  class: "suggestion-container"
}
const _hoisted_22 = { class: "time-entry-upload-section-name-how default-text" }
const _hoisted_23 = { class: "suggestion-element-wrapper" }
const _hoisted_24 = { class: "suggestion-button-wrapper" }
const _hoisted_25 = {
  key: 0,
  class: "our-suggestion-wrapper"
}
const _hoisted_26 = { class: "small-text-grey suggestion-message" }
const _hoisted_27 = { class: "suggestions-block" }
const _hoisted_28 = {
  key: 0,
  class: "no-suggestion-text small-text-grey"
}
const _hoisted_29 = { class: "user-suggestion-wrapper" }
const _hoisted_30 = {
  key: 0,
  class: "small-text-grey suggestion-message"
}
const _hoisted_31 = { class: "suggestions-block" }
const _hoisted_32 = {
  key: 0,
  class: "text-area-wrapper"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "technologies-similarity"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "medium-text-grey" }, "Do you mean", -1)
const _hoisted_37 = { class: "similarity-button-container" }
const _hoisted_38 = { class: "similarity-button-container" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "medium-text-grey question-mark" }, "?", -1)
const _hoisted_40 = {
  key: 2,
  class: "how-warning-message small-text-salmon"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { for: "fileDrop" }
const _hoisted_43 = {
  key: 1,
  class: "upload-or-text medium-text-grey"
}
const _hoisted_44 = {
  key: 2,
  class: "medium-text-grey"
}
const _hoisted_45 = { class: "upload-button-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_ring = _resolveComponent("loading-ring")!
  const _component_ta_button = _resolveComponent("ta-button")!
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_profileButton = _resolveComponent("profileButton")!
  const _component_multipleCheckboxSelect = _resolveComponent("multipleCheckboxSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["upload-main-block", {
        'shorter-main-block': !_ctx.loadingStopped,
      }])
    }, [
      (!_ctx.loadingStopped)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.loadingText), 1),
            (!_ctx.failedUploadWarining)
              ? (_openBlock(), _createBlock(_component_loading_ring, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.failedUploadWarining)
              ? (_openBlock(), _createBlock(_component_ta_button, {
                  key: 1,
                  class: "upload-incorrect-button",
                  text: _ctx.understandText,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeUpload()))
                }, null, 8, ["text"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.loadingStopped)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_tooltip, {
                text: _ctx.questionMarkHoverText,
                positionFromTop: 'small'
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["text"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.task.task_name), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: _normalizeClass(["task-color", _ctx.task?.color])
                }, null, 2),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.project.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.firstSectionName), 1),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.requiredSymbol), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profilesOrdered.values(), (profile, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "button-wrapper",
                      key: index
                    }, [
                      profile
                        ? (_openBlock(), _createBlock(_component_profileButton, {
                            key: 0,
                            profile: profile,
                            selectedProfile: _ctx.selectedProfile,
                            onNewProfile: ($event: any) => (
                    _ctx.selectProfile(profile.ID, profile.profile_name, true, true)
                  )
                          }, null, 8, ["profile", "selectedProfile", "onNewProfile"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, [
                _createTextVNode(_toDisplayString(_ctx.secondSectionName), 1),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.requiredSymbol), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_multipleCheckboxSelect, {
                  options: _ctx.options,
                  clickedNewLabel: _ctx.newLabelClicked,
                  onResetSelectActions: _ctx.resetActions
                }, null, 8, ["options", "clickedNewLabel", "onResetSelectActions"])
              ])
            ]),
            (_ctx.showSuggestionArea)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.thirdSectionName), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      (!_ctx.HideOurSuggestionsBlock)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("tag-selection.our-suggestion")), 1),
                            _createElementVNode("div", _hoisted_27, [
                              (_ctx.showNoSuggestionText)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.$t("tag-selection.no-suggestion")), 1))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestionMapData, (suggestion, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  (!suggestion.isRemovable)
                                    ? (_openBlock(), _createBlock(_component_ta_button, {
                                        key: 0,
                                        class: _normalizeClass(["suggestion-button", _ctx.buttonToggleClass(suggestion)]),
                                        closeHover: suggestion.isRemovable,
                                        customClass: _ctx.techButtonClass(suggestion.isRemovable),
                                        backgroundColor: 'dark-text',
                                        text: suggestion.name,
                                        onClick: ($event: any) => (_ctx.toggleSuggestion(suggestion))
                                      }, null, 8, ["closeHover", "customClass", "text", "class", "onClick"]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_29, [
                        (_ctx.showUserTechnologies)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.$t("tag-selection.user-suggestion")), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_31, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestionMapData, (suggestion, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              (suggestion.isRemovable)
                                ? (_openBlock(), _createBlock(_component_ta_button, {
                                    key: 0,
                                    class: _normalizeClass(["suggestion-button", _ctx.buttonToggleClass(suggestion)]),
                                    closeHover: suggestion.isRemovable,
                                    customClass: _ctx.techButtonClass(suggestion.isRemovable),
                                    backgroundColor: 'dark-text',
                                    text: suggestion.name,
                                    onClick: ($event: any) => (_ctx.toggleSuggestion(suggestion))
                                  }, null, 8, ["closeHover", "customClass", "text", "class", "onClick"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    (!_ctx.insertedValue)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("input", {
                            onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.checkTechnologySimilarity && _ctx.checkTechnologySimilarity(...args)), ["enter"])),
                            type: "text",
                            placeholder: "Write additional technologies",
                            ref: "suggestionInput",
                            class: "suggestion-text-area small-text"
                          }, null, 544),
                          _createElementVNode("div", {
                            class: "suggestion-image-div",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkTechnologySimilarity && _ctx.checkTechnologySimilarity(...args)))
                          }, _hoisted_34)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.insertedValue)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_ta_button, {
                              class: "similarity-button",
                              text: _ctx.insertedValue,
                              backgroundColor: 'gray',
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addToSuggestion(_ctx.insertedValue, true)))
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_component_ta_button, {
                              class: "similarity-button",
                              text: _ctx.bestTechnologyMatch,
                              backgroundColor: 'gray',
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addToSuggestion(_ctx.bestTechnologyMatch, false)))
                            }, null, 8, ["text"])
                          ]),
                          _hoisted_39
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showError)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.$t("tag-selection.error-suggestion")), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["dropdown-wrapper", {
            'dropdown-wrapper-hovering': _ctx.uploadTriggered,
          }]),
              onDragenter: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.triggerUploadField && _ctx.triggerUploadField(...args)), ["prevent"])),
              onDragleave: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.triggerUploadField && _ctx.triggerUploadField(...args)), ["prevent"])),
              onDragover: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
              onDrop: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dropFile && _ctx.dropFile(...args)), ["prevent"])),
              ref: "uploadedExcel2"
            }, [
              (!_ctx.showFileName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, [
                      _createVNode(_component_ta_button, {
                        class: "upload-dropdown-button",
                        text: 'Select a file'
                      })
                    ]),
                    _createElementVNode("input", {
                      type: "file",
                      id: "fileDrop",
                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args))),
                      ref: "uploadedExcel"
                    }, null, 544)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.showFileName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, " Or drag and drop the file here "))
                : _createCommentVNode("", true),
              (_ctx.showFileName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.fileName), 1))
                : _createCommentVNode("", true)
            ], 34),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_ta_button, {
                class: "cancel-button-upload",
                text: 'CANCEL',
                backgroundColor: 'gray-dark-text',
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeUpload()))
              }),
              _createVNode(_component_ta_button, {
                class: _normalizeClass(["upload-button", {
              'upload-button-disabled': !_ctx.enableUpload,
            }]),
                text: 'UPLOAD',
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sendExcelFile()))
              }, null, 8, ["class"])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}